import { useState } from "react";
import { Eye, Edit3 } from "lucide-react";
import { renderMarkdown } from "@/lib/markdown";

/**
 * Lightweight Markdown textarea with live preview tabs.
 * Supports: # headings, **bold**, *italic*, [text](url), - lists, line breaks.
 */
export default function MarkdownEditor({ value, onChange, rows = 8, testId = "markdown" }) {
  const [tab, setTab] = useState("edit");
  const render = renderMarkdown;

  return (
    <div>
      <div className="mb-2 inline-flex rounded-full bg-wine-50/40 p-1">
        <button type="button" onClick={() => setTab("edit")} className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ${tab === "edit" ? "bg-white text-wine-700 shadow-sm" : "text-neutral-600"}`} data-testid={`${testId}-tab-edit`}>
          <Edit3 className="h-3 w-3" /> Éditer
        </button>
        <button type="button" onClick={() => setTab("preview")} className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ${tab === "preview" ? "bg-white text-wine-700 shadow-sm" : "text-neutral-600"}`} data-testid={`${testId}-tab-preview`}>
          <Eye className="h-3 w-3" /> Aperçu
        </button>
      </div>
      {tab === "edit" ? (
        <textarea
          rows={rows}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Écrivez ici… (Markdown supporté : **gras**, *italique*, ## titre, [lien](url))"
          className="w-full rounded-xl border border-neutral-200 bg-white px-4 py-3 text-sm font-mono outline-none focus:border-wine-300"
          data-testid={`${testId}-textarea`}
        />
      ) : (
        <div
          className="prose prose-neutral min-h-[10rem] max-w-none rounded-xl border border-neutral-200 bg-white px-4 py-3 text-sm"
          dangerouslySetInnerHTML={{ __html: render(value || "*Aperçu vide*") }}
          data-testid={`${testId}-preview`}
        />
      )}
    </div>
  );
}
